<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle"
                  data-toggle="collapse"
                  data-target="#navigation-example-2"
                  @click="toggleNavbar">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <router-link to="/register" class="btn btn-primary">
                Sign Up
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page" data-color=""
           data-image="static/img/background/ppe-locator-background.jpg">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                <form method="#" action="#">
                  <div class="card" data-background="color" data-color="blue" style="color: #000;">
                    <div class="card-header" style="text-align: center; padding-bottom: 40px; padding-top: 50px;">
                      <a href="https://ppeslocator.com/">
                        <img style="width: 80%;" src="/static/img/ppes-seiu121rn-logo.jpg" alt="PPEs Locator logo" />
                      </a>
                    </div>
                    <div class="card-content">
                      <div class="form-group">
                        <label>Email Address</label>
                        <input
                          type="text"
                          name="username"
                          v-model="model.username"
                          v-validate="modelValidations.username"
                          placeholder="Email Address"
                          class="form-control input-no-border">
                        <small class="text-danger" v-show="username.invalid">
                          {{ getError('username') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <label>Password</label>
                        <input
                          type="password"
                          name="password"
                          v-model="model.password"
                          v-validate="modelValidations.password"
                          placeholder="Password"
                          class="form-control input-no-border">
                        <small class="text-danger" v-show="password.invalid">
                          {{ getError('password') }}
                        </small>
                      </div>
                    </div>
                    <div class="card-footer text-center" style="text-align: left;">
                      <button type="submit" v-if="!loading" @click.prevent="login()" class="btn btn-primary btn-fill btn-wd ">Submit</button>
                      <button type="button" v-if="loading" class="btn btn-primary btn-wd" disabled="disabled">
                        <span class="btn-label">
                          <i class="fa fa-circle-o-notch fa-spin"></i>
                        </span>
                        Submit
                      </button>
                      <div class="forgot" style="text-align: right; padding-top: 40px;">
                        &nbsp;
                        <a v-if="model.username != '' && !this.loading" href="#" v-on:click="forgotPassword()">
                          Forgot your password?
                        </a>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright">
              Copyright &copy; 2020 Interdisciplinary Humanistic Technologies All rights reserved.
            </div>
          </div>
        </footer>
        <div class="full-page-background" style="background-image: url(static/img/background/ppe-locator-background.jpg) "></div>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link to="/register" tag="li">
          <a>Sign Up</a>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script>
  import swal from 'sweetalert2'
  import {mapFields} from 'vee-validate'
  import store from '@/store'

export default {
    computed: {
      ...mapFields(['username', 'password'])
    },
    data () {
      return {
        model: {
          username: '',
          password: ''
        },
        modelValidations: {
          username: {
            required: true
          },
          password: {
            required: true
          }
        },
        loading: false,
        axios_config: {
          headers: {
            'Content-Type': 'application/json',
            Authorization: ''
          },
          responseType: 'text'
        },
        axios_post_config: {
          headers: {
            'Content-Length': 0,
            'Content-Type': 'text/plain',
            Authorization: ''
          },
          responseType: 'text'
        },
        user: {},
        business_defaults: {
          'business_name': '',
          'business_id': '',
          'email_content': {
            'invite_wait_period': 3,
            'coupon_code': 'NOT PROVIDED',
            'discount_text': 'NO DISCOUNT PROVIDED'
          },
          'address': {
            'zipcode': '',
            'state': '',
            'city': '',
            'line2': '-',
            'line1': ''
          },
          'other_url': '',
          'business_email': '',
          'business_url': '',
          'shopify_webhook_key': 'NOT PROVIDED',
          'phone_number': ''
        }
      }
    },
    methods: {
      login () {
        this.loading = true
        this.$cognitoAuth.signin(this.model.username.toLowerCase(), this.model.password, (err, result) => {
          if (err) {
            this.error = err
            console.error(err)
            swal({
              title: 'Error',
              text: err.message,
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            })
            this.loading = false
          } else {
            // now authenticate to get full user details and add to store session
            this.$cognitoAuth.isAuthenticatedWithAttributes((err, response) => {
              if (err) {
                console.log(err)
              }
              if (!response) {
                console.log('just logged in but fetching authenticated user failed')
              }
              this.user = response
              console.log(this.user)
              store.setUser(this.user)
              this.loading = false
              this.$router.replace(this.$route.query.redirect || '/admin/ppes-requests')
            })
            // done with store session
            // this.$router.replace(this.$route.query.redirect || '/admin/profile')
          }
        })
      },
      forgotPassword () {
        this.loading = true
        swal({
          title: 'Reset Password?',
          text: `A verification code will be sent to your phone (or email address).`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Yes',
          buttonsStyling: false
        }).then(() => {
          this.resetPassword()
        }, () => {
          this.loading = false
        })
      },
      resetPassword () {
        this.$cognitoAuth.forgotPassword(this.model.username.toLowerCase(), (err, result) => {
          if (err) {
            this.loading = false
            console.log(err)
            swal({
              title: 'Error',
              text: err.message,
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            })
          } else {
            console.log(result)
            swal({
              title: `Password Reset Sent`,
              text: 'Please use the validation code in the message we sent to reset your password on the next page.',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-success btn-fill',
              type: 'success'
            }).then(() => {
              console.log('confirm button clicked')
              this.loading = false
              this.$router.replace(this.$route.query.redirect || '/confirm-password?username=' + this.model.username)
            }, () => {
              console.log('alternate route')
              this.loading = false
              this.$router.replace(this.$route.query.redirect || '/confirm-password?username=' + this.model.username)
            })
          }
        })
      },
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      }
    },
    beforeDestroy () {
      this.closeMenu()
    },
    mounted: function () {
      this.$nextTick(function () {
        if (this.$route.query.username) {
          this.model.username = this.$route.query.username
        }
        if (this.$route.query.logout) {
          this.$cognitoAuth.logout((err, result) => {
            if (err) {
              this.error = err
              console.error(err)
              swal({
                title: 'Error',
                text: err.message,
                type: 'error',
                confirmButtonClass: 'btn btn-info btn-fill',
                buttonsStyling: false
              })
            } else {
              swal({
                title: `Success!`,
                text: 'You were logged out.',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-success btn-fill',
                type: 'success'
              })
              // this.$router.replace(this.$route.query.redirect || '/dashboard')
            }
          })
        }
      })
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Login.vue